import { ROUTES } from "@editor/ui-utils";
import { getChannelListComponent } from "@modules/channel-editor-ui-components";
const de = {
  channels: {
    plural: "Kanäle",
    basics: "Basics",
    backButton: "Zurück",
    settingsLabel: "Linkbox-Konfiguration",
    createChannel: "Channel Erstellen",
    editChannel: "Channel bearbeiten",
    secondaryChannels: "Sekundäre Channels",
    config: "Konfiguration",
    messageNotSelf: "Der übergeordnete Channel kann nicht dieser Channel sein",
    messageMandatoryInfo: "Du kannst den Channel noch nicht speichern, da benötigte Informationen fehlen",
    messageMandatoryInfoConfig: "Du kannst den Channel noch nicht speichern, da benötigte Informationen in der Channelconfig fehlen",
    messageCreated: "Channel erstellt",
    messageUpdated: "Channel aktualisiert",
    messageDeleted: "Channel gelöscht",
    name: "Channel-Name",
    parentChannel: "Übergeordneter Channel",
    seoTitle: "SEO-Zeile",
    seoDescription: "SEO-Beschreibung",
    adTags: "Werbetags",
    markAsAd: "Als Anzeige kennzeichnen",
    adsEnabled: "Werbung aktivieren",
    defaultConfig: "Standard-Channelkonfiguration nutzen",
    goToChannel: "zum Channel",
    errorMandatoryFields: "Entschuldigung, du kannst den Channel nicht speichern, weil nicht alle Pflichtfelder ausgefüllt sind",
    articles: "Anzahl der Artikel",
    contentItems: "Anzahl der Items",
    excludedChannels: "Ausgeschlossene Kanäle",
    checkWhiteSpace: "Sie haben ein Leerzeichen am Anfang geschrieben, was nicht erlaubt ist.",
    noEditTooltip: "„Dieser Kanal stammt ursprünglich vom {source}-Editor",
    errorFailedLoadChannel: "Fehler beim Laden des Kanals",
    handledInLegacySystem: "Eine Änderung der Linkbox-Einstellungen wirkt sich auf mögliche Sub-Channels aus.",
    useParentChannelSettings: "Linkbox-Einstellungen des übergeordneten Channels verwenden",
    channelChangeConfirmationDialog: "Bist du sicher, dass du diese Einstellungen speichern möchtest? Die Änderungen werden direkt auf den betroffenen Artikel- und Channelseiten sichtbar.",
    migration: "Migration",
    path: "Pfad",
    slug: "URL-Slug",
    noIndex: "NoIndex aktivieren",
    noFollow: "NoFollow aktivieren",
    slugChangeConfirmationTitle: "Möchtest du den URL-Slug wirklich ändern?",
    slugChangeConfirmationMessage: "Warnhinweis: Das Ändern des URL-Slugs wirkt sich auf alle zugehörigen Artikel-URLs aus und kann bestehende Links ungültig machen, was das Suchmaschinen-Ranking und die Benutzerfreundlichkeit beeinträchtigen könnte. Bitte sprich vorher mit dem SEO-Team oder den zuständigen Personen, um sicherzustellen, dass die Änderung sinnvoll und notwendig ist.",
    messageExistingArticles: "Kanal kann aufgrund von veröffentlichten Artikeln nicht gelöscht werden.",
    deleteChannelMessage: "Bist du dir sicher, dass du den Kanal löschen möchtest? Alle Unterkanäle werden ebenfalls gelöscht und alle Artikel werden dadurch offline genommen!",
    deleteChannel: "Channel löschen",
    markAsSpecial: "Als Special kennzeichnen",
    specialConfirmModal: {
      yes: "Ja",
      cancel: "Abbrechen",
      title: "Als regulären Channel kennzeichnen",
      message: "Bist du sicher, dass du diesen Channel als regulären Channel kennzeichnen willst? Alle Daten des Specials gehen verloren!"
    },
    specialImageSelectorLabel: "Logo auswählen oder hochladen (optional) ",
    logoLinkUrl: "URL für Logoverlinkung",
    description: "Channel-Beschreibung",
    errorFailedOperation: "Fehler beim Ausführen der letzen Aktion",
    addSelectedChannels: "Ausgewählte Kanäle hinzufügen",
    pagination: "Paginierung"
  },
  channelsList: {
    all: "Alle",
    title: "Channel",
    newButton: "Neuer Channel",
    search: "Nach Channelname suchen",
    searchByBrand: "Nach Marke suchen",
    brand: "Marke",
    loading: "Lade Channel",
    headerTitle: "Titel",
    headerBreadcrumb: "Breadcrumb/Pfad",
    edit: "Bearbeiten",
    view: "Anzeigen",
    mainChannel: "Nach Hauptchannel suchen",
    childChannel: "Nach Untergeordneter Channel suchen",
    hideNoIndexChannels: "Noindex-Channels ausblenden",
    tooltip: 'Hier können Teaser und Links frei definiert werden, um andere Elemente statt Artikel zu verlinken. Werbliche Angebote sollten mit dem Label "Anzeige" gekennzeichnet werden.'
  },
  channelConfigApi: {
    created: "Channelkonfiguration erstellt",
    outdated: "Channelkonfiguration veraltet. Aktualisierung fehlgeschlagen",
    updated: "Channelkonfiguration aktualisiert",
    notFound: "Channelkonfiguration nicht gefunden"
  },
  channelConfig: {
    title: "Channel Titel"
  },
  channelSettings: {
    linkBoxList: "Linkbox-Liste: Platzierung {placementName}",
    addLinkBox: "Linkbox hinzufügen",
    active: "Aktivieren",
    minLinkBoxesError: "Bitte beachte, dass mindestens zwei Linkboxen ausgewählt werden müssen, damit diese auf Artikel- und Channelseiten angezeigt werden.",
    changeLinkBoxSettingsWarn: "Eine Änderung der Einstellungen wirkt sich auf die Sub-Channels aus.",
    placementATooltip: "Platzierung über Outbrain bzw. nach 15 Artikel-Teasern",
    placementBTooltip: "Platzierung integriert in Outbrain-Widget oben bzw. nach 20 Artikel-Teasern",
    placementCTooltip: "Platzierung integriert in Outbrain-Widget unten bzw. nach 25 Artikel-Teasern",
    placementDTooltip: "Platzierung unter Outbrain bzw. nach dem letzten Artikel-Teaser",
    enableHeadlinesPage: "Schlagzeilen-Seite aktivieren",
    excludeHeadlinesSubchannels: "Unterkanäle für die Schlagzeilen-Seite ausschließen",
    checkParentSettingsModal: "Werden die Linkbox-Platzierungen durch den übergeordneten Channel definiert. Die aktuellen Platzierungen werden damit überschrieben. Bist du sicher, dass du fortfahren möchtest?",
    uncheckParentSettingsModal: 'Wenn du das Häkchen der Checkbox "Einstellungen des übergeordneten Channels verwenden" entfernst, werden Änderungen der Linkbox-Platzierungen des übergeordneten Channels nicht mehr übernommen. Bist du sicher, dass du fortfahren möchtest?',
    parentSettingsTooltip: "Same settings of Linkboxes like for parent channel",
    changeParentSettingsModal: "Die Linkbox-Platzierungen wird durch den übergeordneten Channel definiert. Die aktuellen Platzierungen werden überschrieben. Bist du sicher, dass du fortfahren möchtest?",
    paginationEnabled: "Paginierung aktiviert",
    pageLimit: "Seitenlimit",
    teasersPerPage: "Teasers pro Seite",
    startOffset: "Start-Offset"
  },
  channelBlock: {
    messageNoNewBlocks: "Es können keine neuen Blöcke mehr hinzugefügt werden",
    addContent: "Element hinzufügen",
    sourceChannels: "Quellen (Channels)",
    includeSubchannels: "Sub-Channel einschließen",
    stageTitle: "Stage-Titel",
    stageLinkedChannel: "Channel-Link für Stage-Titel",
    placements: "Platzierungen",
    autoArticlePlacement: "Automatischer Artikel",
    fixedArticlePlacement: "Fester Artikel",
    linkoutPlacement: "Freier Teaser",
    listItemArticlePlacement: "Artikel aus Liste",
    apiTeaserPlacement: "API",
    includeSecondaryChannels: "Sekundäre Channels einschließen",
    includeNoIndex: "Artikel auf NoIndex einschließen",
    includeGalleries: "Galerien einschließen"
  },
  channel: {
    blocks: {
      channelArticleBlock: "Artikel-Stage",
      channelImageBlock: "Bild",
      channelInPageWidgetBlock: "Inpage Widget",
      channelMixedBlock: "Gemischte Stage",
      channelTextField: "Textfeld",
      channel: "Channel",
      premiumOnly: "Nur Premiumartikel",
      excludedContent: "Ausgeschlossener Inhalt",
      excludedChannels: "Ausgeschlossene Channel",
      excludedWeights: "Ausgeschlossene Gewichtung",
      channelTags: "Channel Tags (max. 5)",
      stageLayout: "Bühnenlayout",
      standardLayout: "Standard",
      standardLayoutGrid: "Standard Grid",
      headlineOnlyLayout: "Nur Schlagzeilen",
      newstickerLayout: "Newsticker",
      desktopDoubleLayout: "50:50",
      topicBoxLayout: "Topic Box",
      reportingBoxLayout: "Lage Box",
      low: "Niedrig",
      medium: "Mittel",
      high: "Hoch",
      showExceptions: "Ausnahmen anzeigen",
      hideExceptions: "Ausnahmen zusammenklappen",
      messageNotEmptyFixed: "Fixierter Artikel kann nicht leer sein",
      selectArticle: "Artikel auswählen",
      list: "Liste",
      singleGallery: "Einzelne Galerie",
      dayGallery: "Galerie des Tages",
      title: "Titel",
      kicker: "Vorzeile",
      link: "Link",
      label: "Label",
      leadText: "Vorspann",
      selectImage: "Bild auswählen oder hochladen",
      subChannelTags: "Subchannel Tags",
      listSize: "Größe der Artikelliste",
      excludedSubchannels: "Ausgeschlossene Subchannels",
      showPreview: "Vorschau anzeigen",
      hidePreview: "Vorschau verstecken",
      newstickerText: "Der Newsticker zeigt immer die zuletzt veröffentlichten Artikel an.",
      loginwallText: "Nutzer können sich hier registrieren um mehr Inhalte zu sehen. Eingeloggten Benutzern wird dieses Element nicht angezeigt.",
      teaserTextStandard: "Zwei bis sechs Teaser. Ein Hauptteaser, der Rest darunter.",
      teaserStandard: "Standard",
      teaserTextTwoCol: "Genau fünf Teaser. Ein Hauptteaser, der Rest darunter in zwei Spalten.",
      teaserTwoCol: "Zwei Spalten",
      markAsAd: "Artikel als Anzeige markieren",
      bInside: "Bunte Inside",
      duplicatePlacements: "Platzierungseinstellungen kopieren",
      duplicatePlacementsMsg: "Die Platzierungen sind schon vollständig gefüllt.",
      duplicatePlacementsMsg2: "Bitte lösche eine Platzierung, um die Einstellungen zu duplizieren.",
      messageDuplicateContent: "Du hast Content mehrfach in der Channelconfig",
      messageNotFiveArticles: "Es müssen exakt 5 Artikel im Zweispalten-Layout sein",
      messageMinimumArticleCount: "Es müssen mindestens 2 Artikel im Channel sein",
      topbarText: 'Artikel mit der höchsten Priorität werden in Pilot > Home & Top Bar ausgewählt und in der "Meistgelesen"-Stage angezeigt.',
      performanceOffset: "Performanceversatz in Stunden",
      messageVideoCount: "Videoblöcke müssen 3 oder 6 Videos enthalten",
      messageUniqueContent: "Du hast Content mehrfach im Block",
      messageValidateOffset: "Performanceversatz muss ein Wert zwischen 0 und 10 sein",
      mainStageText: "Neuste Artikel mit hoher Priorität werden in Pilot > Home & Top Bar ausgewählt und in der Mainstage angezeigt.",
      personlookText: "Hier wird der Starlook plaziert. Der Inhalt wird von tracdelight befüllt.",
      carouselLayout: "Karussell",
      channelSportHeuteWidgetBlock: "Sport-Heute widget"
    }
  },
  channelsMigration: {
    directEditNotice: "Bitte beachten Sie: Die hier sichtbaren Einstellungen wirken sofort und unabhängig von der Speichern-Funktion. Änderungen treten unmittelbar in Kraft.",
    source: "Herkunft",
    legacyId: "Legacy ID",
    renderedByCtf: "Darstellung durch CTF",
    editableInCtf: "Bearbeitung in Vibe",
    modifiedInCtf: "Geändert in Vibe",
    confirmModal: {
      yes: "Ja",
      cancel: "Abbrechen",
      renderedBy: {
        title: "Darstellung durch CTF ändern",
        message: "Bist du sicher, dass du das darstellende System ändern möchtest?"
      },
      editableIn: {
        title: "Bearbeitung in Vibe ändern",
        message: "Bist du sicher, dass du die Bearbeitung in Vibe erlauben möchtest? Das kann nicht rückgängig gemacht werden!"
      }
    },
    viewCtfVersion: "CTF-Version öffnen"
  }
};
const en = {
  channels: {
    plural: "Channels",
    basics: "Basics",
    backButton: "Back",
    createChannel: "Create Channel",
    editChannel: "Edit Channel",
    secondaryChannels: "Secondary Channels",
    settingsLabel: "Link box configuration",
    config: "Configuration",
    messageNotSelf: "The parent channel can't be this channel",
    messageMandatoryInfo: "You can't save this channel because it is missing mandatory information",
    messageMandatoryInfoConfig: "You can't save this channel because the channel configuration is missing mandatory information",
    messageCreated: "Channel created",
    messageUpdated: "Channel updated",
    messageDeleted: "Channel deleted",
    name: "Channel title",
    parentChannel: "Parent Channel",
    seoTitle: "SEO Title",
    seoDescription: "SEO Description",
    adTags: "Ad Tags",
    markAsAd: "Mark as ad",
    adsEnabled: "Ads enabled",
    defaultConfig: "Use standard channel configuration",
    goToChannel: "Go to channel",
    articles: "Amount of articles",
    contentItems: "Number of items",
    excludedChannels: "Excluded Channels",
    errorMandatoryFields: "Sorry, you can't save this channel because it's missing mandatory information",
    // eslint-disable-line @typescript-eslint/quotes
    checkWhiteSpace: "You wrote a space at the beginning, which is not allowed.",
    noEditTooltip: "This channel is originally from the {source} editor",
    errorFailedLoadChannel: "Error loading channel",
    handledInLegacySystem: "Changing the link box settings will affect possible sub-channels.",
    useParentChannelSettings: "Use link box settings of parent channel",
    channelChangeConfirmationDialog: "Are you sure that you want to save these settings? The changes will directly impact the affected article and channel pages.",
    migration: "Migration",
    path: "Path",
    slug: "Slug",
    noIndex: "Activate NoIndex",
    noFollow: "Activate NoFollow",
    slugChangeConfirmationTitle: "Do you really want to change the URL slug?",
    slugChangeConfirmationMessage: "Warning: Changing the URL slug will affect all related article URLs and may invalidate existing links, which could affect search engine rankings and usability. Please speak to the SEO team or the relevant people beforehand to ensure that the change is sensible and necessary.",
    messageExistingArticles: "Channel cannot be deleted due to published articles.",
    deleteChannelMessage: "Are you sure you want to delete this channel? This will also delete all subchannels and take all articles offline!",
    deleteChannel: "Delete Channel",
    markAsSpecial: "Mark as Special",
    specialConfirmModal: {
      yes: "Yes",
      cancel: "Cancel",
      title: "Mark as regular channel",
      message: "Are you sure you want to mark the channel as a regular channel? This will remove all data related to special channels!"
    },
    specialImageSelectorLabel: "Select or upload image (optional)",
    logoLinkUrl: "Logo link URL",
    description: "Channel description",
    errorFailedOperation: "There was an error performing the latest operation",
    addSelectedChannels: "Add selected channels",
    pagination: "Pagination"
  },
  channelsList: {
    all: "All",
    title: "Channel",
    newButton: "New Channel",
    search: "Search by channel name",
    searchByBrand: "Search by brand",
    brand: "Brand",
    loading: "Loading Channels",
    headerTitle: "Title",
    headerBreadcrumb: "Breadcrumb",
    edit: "Edit",
    view: "Show",
    mainChannel: "Search by Main channel",
    childChannel: "Search by Sub channel",
    hideNoIndexChannels: "Hide noindex channels",
    tooltip: 'Teasers and links can be freely defined here to link other elements instead of articles. Promotional offers should be marked with the label "Advertisement".'
  },
  channelConfigApi: {
    created: "Channel configuration created",
    outdated: "Channel configuration is outdated. Update failed",
    updated: "Channel configuration updated ",
    notFound: "Channel configuration not found"
  },
  channelConfig: {
    title: "Channel Title"
  },
  channelSettings: {
    linkBoxList: "Linkbox List: PLACEMENT {placementName}",
    addLinkBox: "Add Linkbox",
    active: "Active",
    minLinkBoxesError: "Please note that at least two link boxes must be selected for a placement to be displayed on article and channel pages.",
    changeLinkBoxSettingsWarn: "Changing the Linkbox settings will affect subchannels.",
    placementATooltip: "Placement above Outbrain resp. after 15 article teasers",
    placementBTooltip: "Placement integrated in upper part of Outbrain widget resp. after 20 article teasers",
    placementCTooltip: "Placement integrated in lower part of Outbrain widget resp. after 25 article teasers",
    placementDTooltip: "Placement below Outbrain resp. after last article teaser",
    enableHeadlinesPage: "Enable headlines page",
    excludeHeadlinesSubchannels: "Exclude subchannels for headlines page",
    checkParentSettingsModal: 'If you turn on "Use parent channel settings" checkbox, linkboxes placements will be updated by changes made to parent channel. Current placements will be overwritten by parent channel linkboxes placements. Are you sure you want to continue?',
    uncheckParentSettingsModal: 'If you turn off "Use parent channel settings" checkbox, link boxes placements will no longer be updated by changes made to parent channel. Are you sure you want to continue?',
    parentSettingsTooltip: "Same settings of Linkboxes like for parent channel",
    changeParentSettingsModal: "Linkboxes placements will be updated by changes made to parent channel. Current placements will be overwritten by parent channel linkboxes placements. Are you sure you want to continue?",
    paginationEnabled: "Pagination enabled",
    pageLimit: "Page Limit",
    teasersPerPage: "Teasers per page",
    startOffset: "Start Offset"
  },
  channelBlock: {
    messageNoNewBlocks: "You can't add new blocks here anymore",
    addContent: "Add element",
    sourceChannels: "Source Channels",
    includeSubchannels: "Include Subchannels",
    stageTitle: "Stage Title",
    stageLinkedChannel: "Stage Channel Link",
    placements: "Placements",
    autoArticlePlacement: "Auto Article",
    fixedArticlePlacement: "Fixed Article",
    linkoutPlacement: "Linkout",
    listItemArticlePlacement: "List",
    apiTeaserPlacement: "API",
    includeSecondaryChannels: "Include Secondary Channel",
    includeNoIndex: "Include NoIndex",
    includeGalleries: "Include Galleries"
  },
  channel: {
    blocks: {
      channelArticleBlock: "Article Stage",
      channelImageBlock: "Image",
      channelInPageWidgetBlock: "Inpage Widget",
      channelMixedBlock: "Mixed Stage",
      channelTextField: "Text Field",
      channel: "Channel",
      premiumOnly: "Inside only",
      excludedContent: "Excluded content",
      excludedChannels: "Excluded Channels",
      excludedWeights: "Excluded weights",
      stageLayout: "Stage layout",
      standardLayout: "Standard",
      standardLayoutGrid: "Standard Grid",
      headlineOnlyLayout: "Headline Only",
      newstickerLayout: "Newsticker",
      desktopDoubleLayout: "50:50",
      topicBoxLayout: "Topic Box",
      reportingBoxLayout: "Reporting Box",
      low: "low",
      medium: "medium",
      high: "high",
      showExceptions: "Show exceptions",
      hideExceptions: "Hide exceptions",
      messageNotEmptyFixed: "Fixed article can't be empty",
      selectArticle: "Select article",
      list: "List",
      singleGallery: "Single gallery",
      dayGallery: "Gallery of the day",
      title: "Title",
      kicker: "Kicker",
      link: "Link",
      label: "Label",
      leadText: "Lead Text",
      selectImage: "Select or upload image",
      subChannelTags: "Subchannel tags",
      listSize: "Size of article list",
      excludedSubchannels: "Excluded Subchannels",
      showPreview: "Show preview",
      hidePreview: "Hide preview",
      newstickerText: "The newsticker always shows the latest articles.",
      loginwallText: "Customers can register here to see more content. Logged in users don't see this element.",
      channelTags: "Channel Tags (max. 5)",
      teaserTextStandard: "Two to six teasers. One main teaser, the rest below.",
      teaserStandard: "Standard",
      teaserTextTwoCol: "Exactly five teasers. One main teaser, the rest below in two columns.",
      teaserTwoCol: "Two columns",
      markAsAd: "Mark as ad",
      bInside: "Bunte Inside",
      duplicatePlacements: "Duplicate placement settings",
      duplicatePlacementsMsg: "The placements are aleady filled.",
      duplicatePlacementsMsg2: "Please delete a placement to duplicate the placement settings.",
      messageDuplicateContent: "There is duplicate content within the channel configuration",
      messageNotFiveArticles: "There must be exactly five articles in the two column layout",
      messageMinimumArticleCount: "There must be at least two articles in a channel",
      topbarText: 'Articles with the highest priority are selected in Pilot > Home & Top Bar and displayed in the "Meistgelesen" stage.',
      performanceOffset: "Performance offset in hours",
      messageVideoCount: "Video blocks must contain three or six videos",
      messageUniqueContent: "There is duplicate content within this block",
      messageValidateOffset: "Performance offset needs to be a value between 0 and 10",
      mainStageText: "Newest articles with high priority are selected in Pilot > Home & Top Bar and displayed on the main stage.",
      personlookText: "This is the person look. It is filled externally by tracdelight.",
      carouselLayout: "Carousel",
      channelSportHeuteWidgetBlock: "Sport-Heute widget"
    }
  },
  channelsMigration: {
    directEditNotice: "Please note: The settings visible here take effect immediately and are independent of the save function. Changes are applied instantly.",
    source: "Source",
    legacyId: "Legacy ID",
    renderedByCtf: "Rendered by CTF",
    editableInCtf: "Editable in Vibe",
    modifiedInCtf: "Modified in Vibe",
    confirmModal: {
      yes: "Yes",
      cancel: "Cancel",
      renderedBy: {
        title: "Changing Rendered by CTF",
        message: "Are you sure you want to change the rendering system?"
      },
      editableIn: {
        title: "Changing Editable in Vibe",
        message: "Are you sure you want to make the channel editable in CTF? This cannot be undone!"
      }
    },
    viewCtfVersion: "View CTF version"
  }
};
const messages = { en, de };
const routes = [
  {
    path: `/${ROUTES.channels.path}`,
    meta: { i18RouteTitleKey: ROUTES.channels.path },
    children: [
      {
        path: "",
        name: "channel_list",
        component: getChannelListComponent,
        props: (route) => route.query,
        meta: { requiredRight: "navigate_list_channels" }
      },
      {
        path: "new",
        name: "channel_new",
        component: () => import("./channel-edit-BIF9zxk4.js"),
        meta: { requiredRight: "navigate_channel" }
      },
      {
        path: ":id",
        name: "channel_detail",
        component: () => import("./channel-edit-BIF9zxk4.js"),
        props: (route) => ({ id: route.params.id, backRoute: "/channels", tab: route.query.tab }),
        meta: { requiredRight: "navigate_channel" }
      }
    ]
  }
];
const channelModule = {
  messages,
  routes
};
export {
  channelModule
};
//# sourceMappingURL=index.es.js.map
